import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Downshift from 'downshift'

// API
import * as API  from '../../../utils/api'

class SchoolSearchAutocompleteInput extends Component {
  static propTypes = {
    // Required
    onChange: PropTypes.func.isRequired,
    // schoolSearchType Options: 'high school' or 'college'
    schoolSearchType: PropTypes.string.isRequired,

    //Optional
    errorMessage: PropTypes.string,
    showError: PropTypes.bool,
    defaultInputValue: PropTypes.string,
  }

  state = {
    searching: false,
    schools: []
  }

  getNameAttribute(item) {
    if (item.hasOwnProperty("school_name")) {
      return item.school_name
    } else {
      return item.name
    }
  }

  itemToString = (item) => {
    return item == null ? '' : String(this.getNameAttribute(item))
  }

  renderDropdown(schools, inputValue, getItemProps, highlightedIndex, selectedItem) {
    let dropdownInner = schools.length > 0 ?
    (
      schools.map((school, index) => (
        <div
          {...getItemProps({item: school})}
          key={school.id}
          className={`autocomplete-form-input-dropdown-item${highlightedIndex === index ? ' highlighted' : ''}${selectedItem === school ? ' selected' : ''}`}
        >
          {this.getNameAttribute(school)}
          <div className="location">
            {school.city}, {school.state}
          </div>
        </div>
      ))
    )
    : (
      <div
        className="autocomplete-form-input-dropdown-item no-results"
      >
        No Results
      </div>
    )

    return (
      <div
        className="autocomplete-form-input-dropdown"
      >
        {dropdownInner}
      </div>
    )
  }

  renderErrorMessage = (errorMessage) => {
    return errorMessage ? (
      <div className="input-error-message">
        {errorMessage}
      </div>
    ) : ''
  }

  handleAutocompleteInputChange = (inputValue) => {
    if (inputValue) {
      this.setState({
         searching: true,
      }, () => this.updateSchoolOptions(inputValue))
    } else {
      this.setState(state => ({
        ...state,
        schools: []
      }))
    }
  }

  updateSchoolOptions = (query) => {
    const { user, schoolSearchType } = this.props

    if (schoolSearchType === 'college') {
      API.searchColleges(user, query).then((schools) => {
        this.setState(state => ({
          ...state,
          searching: false,
          schools: schools.length > 0 ? schools : []
        }))
      })
    } else if (schoolSearchType === 'high school') {
      API.searchSchools(query).then((schools) => {
        this.setState(state => ({
          ...state,
          searching: false,
          schools: schools.length > 0 ? schools : []
        }))
      })
    }
  }

  render() {
    const {
      onChange,
      showError,
      errorMessage,
      defaultInputValue,
    } = this.props

    const {
      schools,
      searching
    } = this.state

    return (
      <Downshift
        onChange={onChange}
        onInputValueChange={this.handleAutocompleteInputChange}
        itemToString={this.itemToString}
        defaultInputValue={defaultInputValue}
        key={ `school-search-${defaultInputValue}` }
        render={({
          getInputProps,
          getItemProps,
          isOpen,
          selectedItem,
          inputValue,
          highlightedIndex,
          defaultInputValue
        }) => (
          <div className={`autocomplete-form-input${searching ? ' searching' : ''}`}>
            <div className={`input-container ${showError && errorMessage ? ' error' : ''}`}>
              <input
                className={`${isOpen ? ' dropdown-active' : ''}`}
                {...getInputProps({
                  placeholder: 'Type to Search for a School...',
                  type: 'text'
                })}
              />
            </div>
            {isOpen &&
              this.renderDropdown(schools, inputValue, getItemProps, highlightedIndex, selectedItem)
            }
            {showError && this.renderErrorMessage(errorMessage)}
          </div>
        )}
      />
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
  }
}

export default connect(
  mapStateToProps,
  null
)(SchoolSearchAutocompleteInput)



// WEBPACK FOOTER //
// ./src/components/Global/Forms/SchoolSearchAutocompleteInput.js